import axios from "axios";

// export const getVerificationResult = async (
//   sessionID: string
// ): Promise<any> => {
//   if (process.env.REACT_APP_AIPRISE_SANDBOX_API_KEY) {
//     const options = {
//       method: "GET",
//       headers: {
//         accept: "application/json",
//         "X-API-KEY": process.env.REACT_APP_AIPRISE_SANDBOX_API_KEY,
//       },
//     };

//     return await fetch(
//       `https://api-sandbox.aiprise.com/api/v1/verify/get_user_verification_result/${sessionID}`,
//       options
//     )
//       .then((response) => response.json())
//       .then((response) => {
//         // console.log(response);
//         return response;
//       })
//       .catch((err) => {
//         // console.error(err);
//         return err;
//       });
//   }
// };

// export const getVerificationData = async (sessionID: string): Promise<any> => {
//   if (process.env.REACT_APP_AIPRISE_SANDBOX_API_KEY) {
//     const options = {
//       method: "GET",
//       headers: {
//         accept: "application/json",
//         "X-API-KEY": process.env.REACT_APP_AIPRISE_SANDBOX_API_KEY,
//       },
//     };

//     fetch(
//       `https://api-sandbox.aiprise.com/api/v1/verify/get_user_data_from_request/${sessionID}`,
//       options
//     )
//       .then((response) => response.json())
//       .then((response) => {
//         console.log(response);
//         return response;
//       })
//       .catch((err) => {
//         console.error(err);
//         return err;
//       });
//   }
// };

export const getVerificationResult = async (sessionID: string) => {
  const options = {
    headers: {
      accept: "application/json",
      "X-API-KEY": process.env.REACT_APP_AIPRISE_SANDBOX_API_KEY || "",
    },
  };

  try {
    const response = await axios.get(
      `https://api-sandbox.aiprise.com/api/v1/verify/get_user_verification_result/${sessionID}`,
      options
    );

    // console.log(response.data);

    return response.data;
  } catch (err) {
    console.log(err);

    return err;
  }
};

export const getVerificationData = async (sessionID: string) => {
  const options = {
    headers: {
      accept: "application/json",
      "X-API-KEY": process.env.REACT_APP_AIPRISE_SANDBOX_API_KEY || "",
    },
  };

  try {
    const response = await axios.get(
      `https://api-sandbox.aiprise.com/api/v1/verify/get_user_data_from_request/${sessionID}`,
      options
    );

    // console.log(response.data);

    return response.data;
  } catch (err) {
    console.log(err);

    return err;
  }
};
